import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause, faStepForward, faStepBackward, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ScrubBar } from './ScrubBar';
import { VolumeControl } from './VolumeControl';
import { AddToStationButton } from './AddToStationButton';
import { BEM, renderClassName } from '@feedfm/feed-util';

import './PlayerControls.scss';

const bem = new BEM( 'echo-chamber' );
interface PlayerControlsProps {
  isPlaying: boolean;
  onPlayPause?: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
  onClose: () => void;
  // audioFileId: number;
  // audioRef: React.RefObject<HTMLAudioElement>;
  duration: number;
  currentTime: number;
  setScrub: ( time: number ) => void;
  setAudioRefVolume: ( volume: number ) => void;
  onAddToStation?: () => void;
  pregain?: number;
}

const formatTime = ( seconds: number ) => {
  const minutes = Math.floor( seconds / 60 );
  const remainingSeconds = Math.floor( seconds % 60 );
  return `${minutes}:${remainingSeconds.toString().padStart( 2, '0' )}`;
};
const gainAdjustedVolume = ( volume: number, gain: number ) => {
  if ( gain === 0 ) {
    return volume;
  }

  // Convert pregain from dB to linear scale
  const linearGain = Math.pow( 10, gain / 20 );

  // Apply the gain adjustment
  let adjustedVolume = volume * linearGain;

  // Clamp the adjusted volume to the range [0, 1]
  adjustedVolume = Math.min( Math.max( adjustedVolume, 0 ), 1 );
  return adjustedVolume;
};
export const PlayerControls: React.FC<PlayerControlsProps> = ( {
  isPlaying,
  onPlayPause,
  onNext,
  onPrevious,
  onClose,
  duration,
  currentTime,
  setScrub,
  setAudioRefVolume,
  onAddToStation,
  pregain,
} ) => {
  const [volume, setVolume] = useState<number>( 1.0 );

  useEffect( () => {
    const adjustedVolume = gainAdjustedVolume( volume, pregain || 0 );
    setAudioRefVolume( adjustedVolume );
  }, [volume, pregain, setAudioRefVolume] );

  return (
    <div className={ renderClassName( bem.el( 'player-controls' ) ) }>
      <button className="control-btn" onClick={ onPrevious } disabled={ !onPrevious }>
        <FontAwesomeIcon icon={ faStepBackward } />
      </button>
      <button className="control-btn" onClick={ onPlayPause }>
        <FontAwesomeIcon icon={ isPlaying ? faPause : faPlay } />
      </button>
      <button className="control-btn" onClick={ onNext } disabled={ !onNext }>
        <FontAwesomeIcon icon={ faStepForward } />
      </button>
      <ScrubBar currentTime={ currentTime || 0 } duration={ duration } onSeek={ setScrub } />
      <div className={ renderClassName( bem.el( 'time-display' ) ) }>
        { formatTime( currentTime ) } / { formatTime( duration ) }
      </div>
      <VolumeControl onVolumeChange={ setVolume } />
      { onAddToStation && <AddToStationButton onAddToStation={ onAddToStation } /> }
      <button className="control-btn" onClick={ onClose }>
        <FontAwesomeIcon icon={ faTimes } />
      </button>
    </div>
  );
};
